(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const desktopEnvironment = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
    const touchEnvironment = window.matchMedia('(any-pointer: coarse)');

    const fallbackCopy = (value) => {
      const input = document.createElement('textarea');
      const activeElement = document.activeElement;
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      input.style.fontSize = '16px';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.focus({ preventScroll: true });
      input.select();
      input.setSelectionRange(0, value.length);

      let copied = false;
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        copied = false;
      }

      input.remove();
      activeElement?.focus({ preventScroll: true });
      return copied;
    };

    const copyText = (value) => {
      const fallbackCopied = fallbackCopy(value);

      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(value)
          .then(() => true)
          .catch(() => fallbackCopied);
      }

      return Promise.resolve(fallbackCopied);
    };

    const initializeExternalStores = (root = document) => {
      root.querySelectorAll('[data-external-store-link][data-app-only="true"]').forEach((link) => {
        if (link.dataset.externalStoreInitialized === 'true') return;
        link.dataset.externalStoreInitialized = 'true';

        link.addEventListener('click', (event) => {
          if (!desktopEnvironment.matches || touchEnvironment.matches) return;

          const dialog = document.getElementById(link.getAttribute('aria-controls'));
          if (!dialog || typeof dialog.showModal !== 'function') return;

          event.preventDefault();
          dialog.externalStoreOpener = link;
          dialog.showModal();
          dialog.querySelector('[data-dialog-close]')?.focus();
        });
      });

      root.querySelectorAll('[data-external-store-dialog]').forEach((dialog) => {
        if (dialog.dataset.externalStoreInitialized === 'true') return;
        dialog.dataset.externalStoreInitialized = 'true';

        dialog.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => {
          if (dialog.externalStoreOpener?.isConnected) dialog.externalStoreOpener.focus();
        });

        const copyButton = dialog.querySelector('[data-copy-link]');
        const confirmation = dialog.querySelector('[data-copy-confirmation]');
        let confirmationTimer;

        copyButton?.addEventListener('click', async () => {
          const copied = await copyText(dialog.dataset.storeUrl || '');
          if (!copied || !confirmation) return;

          confirmation.hidden = false;
          window.clearTimeout(confirmationTimer);
          confirmationTimer = window.setTimeout(() => {
            confirmation.hidden = true;
          }, 2500);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeExternalStores(), { once: true });
    } else {
      initializeExternalStores();
    }

    document.addEventListener('shopify:section:load', (event) => initializeExternalStores(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
